// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__SSTxB","footer":"ReportModalFilter_footer__3BYy-"};